/* Handles the experiment datalayer for tracking AB tests in Google Analytics */
import Cookie from 'cookie';
const cookies = Cookie.parse(document.cookie)

// we want all cookies set with the below as all experiment cookies are named this way
const cookiePrefix = 'experiment_cookie_';


window.dataLayer = window.dataLayer || [];

// loop through each cookie and output the value into the datalayer
Object.entries(cookies).forEach(([name, value]) => {
	if (name.startsWith(cookiePrefix)) {
	  const experimentKey = name.slice(cookiePrefix.length);
	  window.dataLayer.push({
		'event': 'experiment',
		'experiment_variant': value,
		'experiment_name': experimentKey,
	  });
	}
});